import { __decorate, __metadata } from "tslib";
import { TransformWithLVS } from '@goparrot/common';
import { ApiProperty } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsEnum, IsInt, IsNotEmpty, IsOptional, IsPositive, Min, ValidateNested } from 'class-validator';
import { LoyaltyProgramExposeGroupEnum, SpendRuleTargetEnum } from '../interface';
import { CreateLoyaltyPromotionDto } from './CreateLoyaltyPromotionDto';
export class CreateSpendRuleDto {
    constructor() {
        this.target = SpendRuleTargetEnum.ONLINE;
    }
}
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsNotEmpty({ always: true }),
    __metadata("design:type", String)
], CreateSpendRuleDto.prototype, "uuid", void 0);
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsNotEmpty({ always: true }),
    IsPositive({ always: true }),
    __metadata("design:type", Number)
], CreateSpendRuleDto.prototype, "points", void 0);
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsOptional({ always: true }),
    IsInt({ always: true }),
    Min(0, { always: true }),
    __metadata("design:type", Number)
], CreateSpendRuleDto.prototype, "minPointsAvailableCheck", void 0);
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsNotEmpty({ always: true }),
    Type(() => CreateLoyaltyPromotionDto),
    ValidateNested({ always: true }),
    __metadata("design:type", CreateLoyaltyPromotionDto)
], CreateSpendRuleDto.prototype, "promotion", void 0);
__decorate([
    ApiProperty({ enum: SpendRuleTargetEnum }),
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.READ] }),
    IsEnum(SpendRuleTargetEnum, { always: true }),
    TransformWithLVS(({ value }) => value || SpendRuleTargetEnum.ONLINE),
    __metadata("design:type", String)
], CreateSpendRuleDto.prototype, "target", void 0);
//# sourceMappingURL=CreateSpendRuleDto.js.map